<template>
<!--S 新闻中心   -->
  <section class="wraper">
    <div class="banner">
      <img src="../../../assets/images/newsCenter/banner.jpg" width="100%" >
    </div>
    <div v-show="li" class="container">
    <h3 class="title">
      <span>新闻中心/News</span>
    </h3>
    <p class="title-sub">科学，创新进取，专业高效，诚信服务</p>
    <hr>
      <ul>
        <li @click="detail(item.id)" v-for="(item,index) of newscenter" :key="index">
          {{item.name}}
        </li>
      </ul>
      <paginations :totalPage="totalPage" @currentChange="pageClick"/>
    </div>
  </section>
</template>
<script>
import { post, get } from "@/axios/index";
import Paginations from '@/components/common/paginations'
export default {
  components: {
    Paginations,
  },
  data() {
    return {
      li: true,
      totalPage: 1,
      newscenter:[],
      totalPage: 0,
      form: {
        page: 1,
        size: 30
      }
    }
  },
  methods: {
    pageClick(index) {
      this.form.page = index;
      this.getnewscenterinfo();
    },
     //跳转新闻详情页
    detail(id) {
      this.$router.push({
        path: "/pc/news-details",
        query: {
          id: id
        }
      });
    },
    async getnewscenterinfo() {
      try {
        const { data: { result: { pageData, total }}} = await get("/stknewscenterinfo/getnewscenterinfo", this.form);
        this.newscenter = pageData;
        this.totalPage = total;
      } catch (error) {
        
      }
    }
  },
  mounted() {
    this.getnewscenterinfo();
  }
}
</script>
<style lang="less" scoped>
.wraper {
  width: 100%;
  height: 100%;
  .banner {
    // width: 100%;
    // height: 360px;
    // overflow: hidden;
    // background: url('../../../assets/images/newsCenter/banner.jpg') left center no-repeat;
    // background-size: 100% 100%;
  }
  .container {
    width: 1060px;
    height: 100%;
    overflow: hidden;
    margin: 0 auto;
    .title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: relative;
      margin-top: 20px;
      span {
        font-family: AdobeHeitiStd-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #4a4a4a;
        display: inline-block;
        padding: 0 33px;
        background-color: #fcfcfc;
        position: relative;
      }
    }
    .title-sub {
      width: 100%;
      text-align: center;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      margin-top: 11px;
      margin-bottom: 11px;
      .color333;
    }
    hr {
      margin: 20px 0;
    }
    ul {
      width: 100%;
      height: auto;
      list-style: circle!important;
      list-style-type: circle!important;
      li {
        cursor: pointer;
        line-height: 30px;
        padding: 10px 20px;
        border-bottom: 1px solid #ccc;
        width: 1050px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        &:hover {
          text-decoration: underline;
          color: #2ba0fe;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/newsCenter/index.vue